import { Navigate } from "react-router-dom";

import { useAuth } from "../core/auth";
import MissionAdminLayout from "../Routes/mission-admin/layout";
import MissionAdminLogin from "../Routes/mission-admin/login/page";
import MissionAdminCampaignsList from "../Routes/mission-admin/campaigns/list/page";
import MissionAdminCampaignsCreate from "../Routes/mission-admin/campaigns/create/page";
import MissionAdminCampaignsDetail from "../Routes/mission-admin/campaigns/detail/page";
import MissionAdminCampaignsEdit from "../Routes/mission-admin/campaigns/edit/page";
import MissionAdminTemplates from "../Routes/mission-admin/templates/page";
import MissionAdminBrands from "../Routes/mission-admin/brands/page";
import MissionAdminContractsCreate from "../Routes/mission-admin/contracts/create/page";
import MissionAdminContractsConnect from "../Routes/mission-admin/contracts/connect/page";
import MissionAdminContractsEdit from "../Routes/mission-admin/contracts/[contractId]/edit/page";
import ReviewsDashboard from "../Routes/mission-admin/reviews/page";
import SubmissionsList from "../Routes/mission-admin/reviews/submissions/page";
import SubmissionDetail from "../Routes/mission-admin/reviews/submissions/[participationId]/page";
import WithdrawalsList from "../Routes/mission-admin/reviews/withdrawals/page";
import WithdrawalDetail from "../Routes/mission-admin/reviews/withdrawals/[withdrawalRequestId]/page";
import SuccessesList from "../Routes/mission-admin/reviews/successes/page";
import FailuresList from "../Routes/mission-admin/reviews/failures/page";
import SettlementIssue from "../Routes/mission-admin/settlement-issue/page";

const MissionAdminAuth = ({ children }: { children: JSX.Element }) => {
  const { isAdministratorLoggedIn } = useAuth();

  if (isAdministratorLoggedIn) {
    return <MissionAdminLayout>{children}</MissionAdminLayout>;
  }

  return <Navigate to="/ops/mission/login" />;
};

// prettier-ignore
export const missionAdminRoutes = [
  {
    path: "/ops/mission/login",
    element: <MissionAdminLogin />,
  },
  {
    path: "/ops/mission/campaigns",
    element: (
      <MissionAdminAuth>
        <MissionAdminCampaignsList />
      </MissionAdminAuth>
    ),
  },
  {
    path: "/ops/mission/campaigns/create",
    element: (
      <MissionAdminAuth>
        <MissionAdminCampaignsCreate />
      </MissionAdminAuth>
    ),
  },
  {
    path: "/ops/mission/campaigns/:campaignId",
    element: (
      <MissionAdminAuth>
        <MissionAdminCampaignsDetail />
      </MissionAdminAuth>
    ),
  },
  {
    path: "/ops/mission/campaigns/:campaignId/edit",
    element: (
      <MissionAdminAuth>
        <MissionAdminCampaignsEdit />
      </MissionAdminAuth>
    ),
  },
  {
    path: "/ops/mission/templates",
    element: (
      <MissionAdminAuth>
        <MissionAdminTemplates />
      </MissionAdminAuth>
    ),
  },
  {
    path: "/ops/mission/brands",
    element: (
      <MissionAdminAuth>
        <MissionAdminBrands />
      </MissionAdminAuth>
    ),
  },
  {
    path: "/ops/mission/contracts/create",
    element: (
      <MissionAdminAuth>
        <MissionAdminContractsCreate />
      </MissionAdminAuth>
    ),
  },
  {
    path: "/ops/mission/contracts/connect",
    element: (
      <MissionAdminAuth>
        <MissionAdminContractsConnect />
      </MissionAdminAuth>
    ),
  },
  {
    path: "/ops/mission/contracts/:contractId/edit",
    element: (
      <MissionAdminAuth>
        <MissionAdminContractsEdit />
      </MissionAdminAuth>
    ),
  },
  {
    path: "/ops/mission/reviews",
    element: (
      <MissionAdminAuth>
        <ReviewsDashboard />
      </MissionAdminAuth>
    ),
  },
  {
    path: "/ops/mission/reviews/submissions",
    element: (
      <MissionAdminAuth>
        <SubmissionsList />
      </MissionAdminAuth>
    ),
  },
  {
    path: "/ops/mission/reviews/submissions/:participationId",
    element: (
      <MissionAdminAuth>
        <SubmissionDetail />
      </MissionAdminAuth>
    ),
  },
  {
    path: "/ops/mission/reviews/withdrawals",
    element: (
      <MissionAdminAuth>
        <WithdrawalsList />
      </MissionAdminAuth>
    ),
  },
  {
    path: "/ops/mission/reviews/withdrawals/:withdrawalRequestId",
    element: (
      <MissionAdminAuth>
        <WithdrawalDetail />
      </MissionAdminAuth>
    ),
  },
  {
    path: "/ops/mission/reviews/successes",
    element: (
      <MissionAdminAuth>
        <SuccessesList />
      </MissionAdminAuth>
    ),
  },
  {
    path: "/ops/mission/reviews/failures",
    element: (
      <MissionAdminAuth>
        <FailuresList />
      </MissionAdminAuth>
    ),
  },
  {
    path: "/ops/mission/settlement-issue",
    element: (
      <MissionAdminAuth>
        <SettlementIssue />
      </MissionAdminAuth>
    ),
  },
];
